import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../../graphQL';

const query = gql`
mutation deleteGoal($id:Int!) {
    deleteGoal(id: $id)
},
`;

/**
 * Marks the first experience as read.
 *
 * @returns {Promise<boolean>}
 */
export default async function deleteGoal(id: number) {
    const variables: OperationVariables = {
        id,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
